import * as React from 'react'
import { PaymentEventDateType, PaymentRefererType } from '../../../../commons/PaymentFormStatus'

import { Plan } from '../../../../commons/Plan'
import { Referer } from '../../../../commons/Referer'
import Button from '../../atoms/Button/Button'
import FormLayout from '../../molecules/FormLayout/FormLayout'
import * as styles from './ConfirmPaymentForm.css'

interface ConfirmPaymentFormProps {
  cardLast4: string
  firstName: string
  familyName: string
  isLoading: boolean
  plan: Plan
  selectedDateOption: string
  eventDate: string
  selectedRefererOption: string
  otherReferer: string
  error: string | null
  handleClickPayment: () => void
  handleClickFixLink: () => void
}

const ConfirmPaymentForm: React.FunctionComponent<ConfirmPaymentFormProps> = ({
  cardLast4,
  firstName,
  familyName,
  plan,
  selectedDateOption,
  eventDate,
  selectedRefererOption,
  otherReferer,
  isLoading,
  handleClickFixLink,
  handleClickPayment,
  error
}) => {
  const planInfo = Plan.info(plan)
  const refererInfo = Referer.info(Number(selectedRefererOption))
  return (
    <div>
      <div className={styles.paymentInput}>
        <FormLayout title="お名前">
          <p className={styles.baseText}>{`${firstName} ${familyName}`}</p>
        </FormLayout>
      </div>
      <div className={styles.paymentInput}>
        <FormLayout title="カード番号">
          <p className={styles.baseText}>{`**** **** **** ${cardLast4}`}</p>
        </FormLayout>
      </div>
      <div className={styles.paymentAmount}>
        <FormLayout title="お支払い金額">
          <p className={styles.planName}>{planInfo.name}</p>
          <p className={styles.price}>税込 {planInfo.priceWithTax}円</p>
        </FormLayout>
      </div>
      <div className={styles.paymentInput}>
        <FormLayout title="ご利用予定日">
          <p className={styles.baseText}>{selectedDateOption === PaymentEventDateType.UNKNOWN ? '未定' : eventDate}</p>
        </FormLayout>
      </div>
      <div className={styles.paymentReferer}>
        <FormLayout title="Ennoshitaを知ったきっかけ">
          <p className={styles.baseText}>
            {selectedRefererOption !== PaymentRefererType.OTHER ? refererInfo.name : otherReferer}
          </p>
        </FormLayout>
      </div>
      {error ? <p className={styles.errorMessage}>{error}</p> : null}
      <div className={styles.fixLink}>
        <span className={styles.fixLinkText} onClick={handleClickFixLink}>
          登録情報を修正する
        </span>
      </div>
      <div className={styles.payButton}>
        <Button handleClick={handleClickPayment} isLoading={isLoading} isPaid={false}>
          <p>購入する</p>
        </Button>
      </div>
    </div>
  )
}

export default ConfirmPaymentForm
